<template>
  <v-ons-page>
      <div class="aio-container">
        <div class="home-header">
          <h1 class="subtile-home">Sélectionnez votre bureau</h1>
          <div class="link-menu"> 
            <div class="management-btn" @click="manageTeam()">
              <img  style="width:100%; height:auto; cursor:pointer;" src="../../assets/bouton-gestion-des-equipes.png"/>
            </div>
            <div class="disconnect" @click="goTo('logout')"> 
              <p>Déconnexion</p>
            </div>
          </div>
        </div>
        <br>
        <div class="home-content-wrapper">
        <div class="team-wrapper">
          <b-row>
            <b-col v-for="(desk, name, index) in offices" :key="index">
              <h4 class="label team-name"> {{name}}</h4>
              <hr class="label-separator">
              <div class="btn-group-team-selection">
                <b-button 
                  class="btn-team-selection"
                  v-for="(team, nameTeam, index) in desk" :key="index"
                  @click="goToRoute('/kanban-board/' + name +'/' + nameTeam)"
                >
                  {{nameTeam}}
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        </div>
        <br>
        <team-update-modal
          ref="update-team"
          :offices="offices"
          @supdate-done="updateData"
        >
      </team-update-modal>
      </div>
  </v-ons-page>
</template>

<script>
import server from '../../api/server.vue'
import Navbar from "../../components/navbar/Navbar";
import KanbanBoard from "../../components/board/KanbanBoard";
import TeamsUpdateModal from '../../components/modals/TeamsUpdateModal'

export default {
  name: "home-page",
  components: {
    Navbar,
    KanbanBoard,
    'team-update-modal': TeamsUpdateModal,
  },
  data() {
    return {
      loading: false,
      offices: {},
    };
  },
  methods: {
    updateData () {
      this.getOfficeTeams()
    },
    makeToast(text, append = false) {
      // eslint-disable-next-line
      let toast = this.$toasted.info(text, {
        theme: "bubble",
        position: "bottom-right",
        duration: 5000
      });
    },
    manageTeam() {
      this.$refs['update-team'].showModal()
    },
    getOfficeTeams() {
      server.getOfficeTeams().then((result) => {
        this.offices = result
      })
    }
  },
  mounted: function() {
   this.getOfficeTeams()
  }
};
</script>

<style lang='scss' scoped>
.page-title {
  text-align: center;
}

.btn:hover {
  cursor: pointer;
}

.home-page {
  margin: auto;
  min-height: calc(100vh - 44px);
}

.validation-button {
  width: 50%;
  min-width: 300px;
  margin: 0 auto;
  margin-bottom: 1%;
  margin-top: 3%;
}

.aio-container {
  width: 100%;
}

.wrapper-btn {
  margin-top: 10em;
}

.btn-group-team-selection {
  overflow: auto;
  height: 60%;
}

.subtile-home {
  width: 100%;
  text-align: center;
  font-weight: bold;
  padding: 1em;
}

.col {
  text-align: center;
  margin: 10px;
}

.home-btn {
  width: 50%;
}

.item-drop {
  width: 40%;
}

.management-btn {
  text-align: right;
  margin: 1rem;
  width: 130px;
  height: 100px;
}

.label.team-name {
  text-transform: uppercase;
  background: -webkit-linear-gradient(#3579f6, #0F6BAF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
}

.label-separator {
    color: #0F6BAF;
    background:linear-gradient(to right, #3e7ff7, #0F6BAF);
    height: 0.7vh;
    // border: 1px solid #0F6BAF;
    border-radius: 7px 7px 7px 7px;
    margin-bottom: 3vh;
}

.btn-team-selection {
  display: block;
  width: 100%;
  padding: 14px 28px;
  text-transform: capitalize;
  font-weight: bold;
  color: #181818;
  background-color: white;
  border:1px solid white;
  border-radius: 5px 5px 5px 5px;
  margin-bottom: 2vh;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
}

.home-content-wrapper {
  background-color: #f3f3f3;
  position: fixed;
  width: 100%;
  height: 100%;
  text-align: center;
}

.team-wrapper {
  width: 80%;
  margin: auto;
}

.btn-group .btn-group-vertical {
  display: block !important;
}

.home-header {
  display: flex;
  margin-top: 2%;
  height: 15vh;
}

.link-menu {
  display: flex;
  flex-direction: column;
  align-items: center;
  
}

.disconnect {
  text-decoration: underline;
}

.disconnect:hover {
  cursor: pointer;
  color: blue;
  padding: 0;
}

</style>



// WEBPACK FOOTER //
// HomePage.vue?666bd19d